import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';

export default function IconsGrid({
    global,
    title,
    items
}) {
    return (
        <section className={`${styles.root} bg-light text-center py-5`}>
            <Container className="py-3">
                <header className="mb-4">
                    {title}
                </header>
                {items && items.length > 0 && (
                    <Row>
                        {(items || []).map((item, index) => (
                            <Col lg={3} md={4} sm={6} className={`${styles.item} my-4`} key={index}>
                                <figure>
                                    <SourceFlowImage
                                        src={item.image ? item.image : "/site-assets/placeholders/icon-placeholder.png"}
                                        size="120x120"
                                        alt={`Icon ${index}`}
                                    />
                                </figure>
                                <article className="px-5">
                                    <h4>{item.title}</h4>
                                    <span dangerouslySetInnerHTML={{__html: item.text}} />
                                </article>
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
        </section>
    )
}